<template>
  <v-container grid-list-xs class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <PC-Table
          name="Chemicals"
          :headers="headers"
          :items="chemicals"
          @edit="edit"
          @remove="remove"
        />
        <PC-Dialog
          type="Chemical"
          label="Chemical Type"
          :showDialog="showDialog"
          :fields="fields"
          @close="close"
          @create="create"
          @save="save"
        />
      </v-flex>
    </v-layout>
    <AdView id="165" />
    <PCModal />
  </v-container>
</template>

<script>
import firebase from "@/firebase";
import AdView from "@/components/AdView";
import PCDialog from "@/components/PCDialog";
import PCModal from "@/components/PCModal";
import PCTable from "@/components/PCTable";

export default {
  components: { AdView, PCDialog, PCModal, PCTable },
  data() {
    return {
      editID: 1,
      newRecord: false,
      showDialog: false,
      chemicals: [],
      fields: [
        {
          name: "Brand",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Product",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Type",
          type: "select",
          value: "",
          items: [
            "sanitizer",
            "stabilizer",
            "acid",
            "soda",
            "baking soda",
            "borax",
            "calcium chloride",
            "borates",
            "salt",
          ],
          classes: ["pa-2", "xs12"],
        },
        {
          name: "Size",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Units",
          type: "select",
          value: "",
          items: ["tablets", "oz", "lbs", "fl oz", "gal", "g", "kg", "ml", "l"],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Amazon Link",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12"],
        },
      ],
      headers: [
        { text: "Brand", align: "left", value: "brand" },
        { text: "Product", align: "left", value: "product" },
        { text: "Type", align: "left", value: "type" },
        { text: "Size", align: "left", value: "size" },
        { text: "Units", align: "left", value: "units" },
        { text: "Amazon Link", align: "left", value: "url" },
        { text: "Actions", align: "left", value: "actions" },
      ],
    };
  },
  computed: {
    chemicalsRef() {
      return firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("chemicals");
    },
  },
  methods: {
    close() {
      this.fields.forEach((field) => (field.value = ""));
      this.showDialog = false;
    },
    create() {
      this.newRecord = true;
      this.showDialog = true;
    },
    async edit(id) {
      this.newRecord = false;
      this.editID = id;
      const chemical = await this.chemicalsRef.doc(id).get();
      const data = chemical.data();
      this.fields[0].value = data.brand;
      this.fields[1].value = data.product;
      this.fields[2].value = data.type;
      this.fields[3].value = data.size;
      this.fields[4].value = data.units;
      this.fields[5].value = data.url;
      this.showDialog = true;
    },
    async remove(id) {
      await this.chemicalsRef.doc(id).delete();
      await this.updateChemicals();
    },
    async save() {
      const data = {
        brand: this.fields[0].value,
        product: this.fields[1].value,
        type: this.fields[2].value,
        size: Number(this.fields[3].value),
        units: this.fields[4].value,
        url: this.fields[5].value,
      };
      if (this.newRecord) {
        await this.chemicalsRef.add(data);
      } else {
        await this.chemicalsRef.doc(this.editID).set(data);
      }
      await this.updateChemicals();
      this.fields.forEach((field) => (field.value = ""));
      this.showDialog = false;
    },
    pushChemical(chemical) {
      const data = chemical.data();
      this.chemicals.push({
        id: chemical.id,
        brand: data.brand,
        product: data.product,
        type: data.type,
        size: data.size,
        units: data.units,
        url: data.url,
      });
    },
    async updateChemicals() {
      this.chemicals = [];
      const chemicals = await this.chemicalsRef.get();
      chemicals.forEach((chemical) => this.pushChemical(chemical));
    },
  },
  async mounted() {
    await this.updateChemicals();
  },
};
</script>
